import { Dispatch } from 'redux';
import { Range } from 'react-input-range';
import { Set } from 'immutable';

import { SortType } from '../../models/Hotels/SortType';

export const SET_SORT_TYPE = 'HOTELS_SET_SORT_TYPE';
export const SET_PRICE_RANGE = 'HOTELS_SET_PRICE_RANGE';
export const SET_STARS = 'HOTELS_SET_STARS';
export const SET_DISTANCE = 'HOTELS_SET_DISTANCE';

export const RESET_FILTERS = 'HOTELS_RESET_FILTERS';

export const resetFiltersAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_FILTERS
});

export const setSortAction = (sortType: SortType) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_SORT_TYPE,
    sortType
});

export const setPriceRangeAction = (range: Range) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_PRICE_RANGE,
    range
});

export const setStarsAction = (stars: Set<number>) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_STARS,
    stars
});

export const setDistanceAction = (distance: number) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_DISTANCE,
    distance
});



// WEBPACK FOOTER //
// ./src/actions/Hotels/filters.ts